/* eslint-disable react/jsx-no-useless-fragment */
import styles from './FeedItemCard.module.scss';

interface FeedItemConditionalLinkProps {
  children: React.ReactNode;
  href?: string;
  onClick?: () => void;
  openInNewTab?: boolean;
}
export function FeedItemConditionalLink(props: FeedItemConditionalLinkProps) {
  const { children, href, onClick, openInNewTab } = props;
  if (href) {
    return (
      <a
        href={href}
        className={styles.linkCard}
        {...(openInNewTab ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
      >
        {children}
        {openInNewTab && <span className={styles.srOnly}>(opens in new tab)</span>}
      </a>
    );
  }
  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={styles.buttonCard}>
        {children}
      </button>
    );
  }
  return <>{children}</>;
}
